import React from 'react';
import { RiCheckboxCircleFill, RiAlertFill, RiErrorWarningFill } from '@remixicon/react';
import { STATUS, STATUS_STYLES } from '../utils/thresholds';

/**
 * Colored pill that surfaces a TrustScore facet status. Used on:
 *   - the hero card (overall status derived from overall_score)
 *   - each factor card's right-hand chip (per-component status)
 *
 * Small enough to be inlined next to titles without wrapping — matches
 * the design's compact `⚠ Acceptable` / `✔ Optimal` badge treatment.
 */
const ICONS = {
  check: RiCheckboxCircleFill,
  alert: RiAlertFill,
  error: RiErrorWarningFill,
};

const TrustScoreStatusPill = ({ status = STATUS.ACCEPTABLE, size = 'sm', className = '' }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES[STATUS.ACCEPTABLE];
  const Icon = ICONS[style.iconKey] || RiAlertFill;
  const sizing =
    size === 'lg'
      ? 'text-sm px-2.5 py-1 gap-1.5'
      : 'text-xs px-2 py-0.5 gap-1';
  return (
    <span
      className={`inline-flex items-center rounded-[6px] font-medium ${style.pillBg} ${style.pillText} ${sizing} ${className}`}
    >
      <Icon className={size === 'lg' ? 'w-4 h-4' : 'w-3.5 h-3.5'} />
      {style.label}
    </span>
  );
};

export default TrustScoreStatusPill;
